import { isArray } from 'lodash';

export * from './helpers/array';
export * from './helpers/css';
export * from './helpers/date';
export * from './helpers/enum';
export * from './helpers/sxProps';

// String
export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const convertToStringOrNull = (newValue: unknown): string | null => {
  if (
    newValue === null ||
    (typeof newValue === 'string' && newValue.length > 0)
  ) {
    return newValue;
  }

  if (typeof newValue === 'number') {
    return newValue.toString();
  }

  return null;
};

// Number
const mathToDecimals = (
  value: number,
  decimals: number,
  mathFunction: (value: number) => number,
) => {
  const multiplier = Math.pow(10, decimals);
  return mathFunction(value * multiplier) / multiplier;
};

export const mathRoundToDecimals = (value: number, decimals: number) => {
  return mathToDecimals(value, decimals, Math.round);
};

export const mathFloorToDecimals = (value: number, decimals: number) => {
  return mathToDecimals(value, decimals, Math.floor);
};

export const regex_IsNumber = new RegExp(`^\\d+(\\.\\d+)?$`, 'g');

export const getRegex_IsNumberToDecimals = (decimals: number) =>
  new RegExp(`^\\d+(\\.\\d{1,${decimals}})?$`, 'g');

export const getNumberOrUndefined = (
  value: number | string | undefined,
): number | undefined => {
  switch (typeof value) {
    case 'number':
      return value;
    case 'string':
      const parsed = parseInt(value);

      return !isNaN(parsed) ? parsed : undefined;
    case 'undefined':
    default:
      return undefined;
  }
};

// Attachments
export const getAttachmentUrl = (empId: string, attachmentId: number) =>
  `/d/bin/employee/${empId}/file/${attachmentId}`;

export const getProfilePictureUrl = (pictureId: string) =>
  `/d/bin/employee/profile/picture/${pictureId}`;

// Misc
export const nullAsUndefined = <T>(value: T): T | undefined =>
  value === null ? undefined : value;

// Attachments
export const getEmployeeAttachmentUrl = (
  employeeId: number,
  attachmentId: number,
) => {
  return `${window.origin}/d/bin/employee/${employeeId}/file/${attachmentId}`;
};

export const openInNewTab = (url: string) => {
  window.open(url, '_blank')?.focus();
};

export const isMobileBrowser = () =>
  /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );

export const redirectToOrigin = (message?: string) => {
  // For debugging what causes redirect:
  // alert(message ?? 'Redirecting user to starting page');
  window.location.replace(window.location.origin);
};

export const validText = (text: string) => {
  if (text === '' || text.length < 1) {
    return false;
  } else {
    return true;
  }
};

// Custom Console Logging

const styledConsoleLog = (
  message: string | string[],
  type: 'error' | 'success' | 'info',
) => {
  const styles = {
    info: `background-color: #00f; color: #fff; font-weight: bold;`,
    error: `background-color: #f00; color: #fff; font-weight: bold;`,
    success: `background-color: #008000; color: #fff; font-weight: bold;`,
  };

  console.log(
    `%c ${isArray(message) ? message.join(' \r\n ') : message} `,
    styles[type],
  );
};

export const browserLogError = (message: string | string[]) =>
  styledConsoleLog(message, 'error');

export const browserLogInfo = (message: string | string[]) =>
  styledConsoleLog(message, 'info');

export const browserLogSuccess = (message: string | string[]) =>
  styledConsoleLog(message, 'success');
